import { geometric_representation_item } from "./index.js";
import { curve_style } from "./index.js";
import { one_direction_repeat_factor } from "./index.js";
import { cartesian_point } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class fill_area_style_hatching extends geometric_representation_item {
    get type() {
        return EntityTypesAP214.FILL_AREA_STYLE_HATCHING;
    }
    get hatch_line_appearance() {
        if (this.hatch_line_appearance_ === void 0) {
            this.hatch_line_appearance_ = this.extractElement(1, false, curve_style);
        }
        return this.hatch_line_appearance_;
    }
    get start_of_next_hatch_line() {
        if (this.start_of_next_hatch_line_ === void 0) {
            this.start_of_next_hatch_line_ = this.extractElement(2, false, one_direction_repeat_factor);
        }
        return this.start_of_next_hatch_line_;
    }
    get point_of_reference_hatch_line() {
        if (this.point_of_reference_hatch_line_ === void 0) {
            this.point_of_reference_hatch_line_ = this.extractElement(3, false, cartesian_point);
        }
        return this.point_of_reference_hatch_line_;
    }
    get pattern_start() {
        if (this.pattern_start_ === void 0) {
            this.pattern_start_ = this.extractElement(4, false, cartesian_point);
        }
        return this.pattern_start_;
    }
    get hatch_line_angle() {
        if (this.hatch_line_angle_ === void 0) {
            this.hatch_line_angle_ = this.extractNumber(5, false);
        }
        return this.hatch_line_angle_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
fill_area_style_hatching.query = [EntityTypesAP214.FILL_AREA_STYLE_HATCHING];
fill_area_style_hatching.expectedType = EntityTypesAP214.FILL_AREA_STYLE_HATCHING;
